<template>

  <v-content>
    <!-- 四川持恒测绘工程监理有限责任公司 -->
    <v-flex id=""
            class="back left-center-style "
            :style=" {background:' linear-gradient(to left, rgba(5, 11, 31, 0.1), rgba(5, 11, 31, 0.8)), url('+ image +')'}">
      <v-flex class="page-name">四川持恒空间科技有限公司
      </v-flex>
    </v-flex>

    <!-- 导航栏 -->
    <v-flex class="center-style">
      <v-bottom-navigation class="navigation"
                           color="primary"
                           horizontal>
        <v-btn @click="toRoll(1)">
          <span>公司简介</span>
        </v-btn>

        <v-btn @click="toRoll(2)">
          <span>发展历程</span>
        </v-btn>

        <v-btn @click="toRoll(3)">
          <span>发展愿景</span>
        </v-btn>

        <v-btn @click="toRoll(5)">
          <span>企业文化</span>
        </v-btn>

        <v-btn @click="toRoll(6)">
          <span>办公地点</span>
        </v-btn>
      </v-bottom-navigation>
    </v-flex>

    <!-- 公司简介 -->
    <v-flex ref="part1"
            class="center-style"
            style="margin: 100px;">
      <v-flex class="part-title">公司简介</v-flex>
      <h4>持恒以科技为源。</h4>
      <p class="desc">
        四川持恒空间科技有限公司一直立足于国土资源技术服务，
        <br>是针对测绘及土地整理行业提供软件技术服务的公司，
        <br>以3S技术（GPS全球定位系统，GIS全球地理信息系统，RS遥感系统）为技术方向。
        <br>通过以RS和GPS作为快速获取和更新基础数据为主要技术手段，
        <br>以GIS作为存贮、管理和分析信息和数据的基础平台，
        <br>成功实现了国土资源信息化建设、水资源实时监控系统、农田质量分等定级管理等诸多案例，
        <br>与国土、交通、水利、农林等行业有着密切的联系与合作。

      </p>
    </v-flex>

    <!-- 发展历程 -->
    <v-flex ref="part2"
            class="center-style">
      <v-flex class="part-title">发展历程</v-flex>
      <v-timeline class="development-history">
        <v-timeline-item v-for="(item, i) in history"
                         :key="i"
                         :color="item.color"
                         small>
          <template v-slot:opposite>
            <span :class="`headline font-weight-bold ${item.color}--text`"
                  v-text="item.year"></span>
          </template>
          <div class="py-4">
            <h2 :class="`headline font-weight-light mb-4 ${item.color}--text`">
              {{item.title}}
            </h2>
            <div>
              {{item.content}}
            </div>
          </div>
        </v-timeline-item>
      </v-timeline>
    </v-flex>

    <!-- 发展愿景 -->
    <v-row ref="part3"
           class="vision-row">

      <!-- 左部 -->
      <v-flex class="vision-title">发展愿景</v-flex>

      <!-- 分割线 -->
      <v-divider vertical></v-divider>

      <!-- 右部-->
      <v-flex class="right-style">
        <h4 style="margin:30px">持恒以技术丰富互联网用户的生活。</h4>
        <p style="margin:10px"
           class="desc">一切以用户价值为依归，将社会责任融入；
          <br>推动科技创新与文化传承，助力各行各业升级，促进社。
        </p>
      </v-flex>
    </v-row>

    <!-- 企业文化 -->
    <v-row ref="part5"
           class="vision-row">

      <!-- 左部 -->
      <v-flex class="vision-title">企业文化</v-flex>

      <!-- 分割线 -->
      <v-divider vertical></v-divider>

      <!-- 右部-->
      <v-flex class="right-style">
        <v-flex v-for="(item,i) in cultureItems"
                :key="'2'+i">
          <h3 style="margin:30px">{{item.title}}</h3>
          <p style="margin:10px"
             class="desc2">{{item.content}}
          </p>
        </v-flex>
      </v-flex>
    </v-row>

    <!-- 办公地点 -->
    <v-flex ref="part6"
            style="margin: 100px 100px 200px 100px;"
            class="center-style">
      <v-flex class="part-title">办公地点</v-flex>
      <img :src="office">

      <v-row>
        <v-flex v-for="(item,i) in officeLocation"
                :key="'3'+i"
                class="office-style">
          <v-flex @click="updateOfficeItem(item.value)"
                  :class="{'culture-selected':officeIndex == item.value}">{{item.location}}</v-flex>

          <v-flex>
            <transition name="slide-fade">
              <v-divider v-if="officeIndex == item.value"
                         style=" border: 2px solid #42a5f6 !important;"></v-divider>
            </transition>
          </v-flex>

          <!-- 地址详情 -->
          <v-flex v-show="officeIndex == item.value">
            <p class="office-location">地址：{{item.address}}
              <br>邮编：{{item.postcode}}
              <br>电话：{{item.telephone}}
            </p>
          </v-flex>
        </v-flex>
      </v-row>
    </v-flex>

  </v-content>

</template>
<script>
export default {
  data () {
    return {
      image: require('@/images/background/breadcrumbs1.jpg'),
      office: require('@/images/office/office.png'),
      //发展历程
      history: [
        {
          color: 'cyan',
          year: '2008',
          title: '公司成立',
          content: '2008年3月，四川持恒空间科技有限公司在成都成立'
        },
        {
          color: 'orangex',
          year: '2010',
          title: '公司初步发展',
          content: '确定公司主要的发展业务，测绘服务、工程监理、土地整理、工程勘察设计、农业、林业规划服务、软件开发、土地规划服务、士地整治服务生态保护和环境治理。'

        },

        {
          color: 'green',
          year: '2016',
          title: '公司改革',
          content: '成立无人机航飞小组、组建空间规划部门，公司获得土地规划乙级资质及测绘乙级资质。'

        },
        {
          color: 'pink',
          year: '2020',
          title: '全面启航',
          content: '承接全国多个国土空间规划信息平台建设项目'
        }
      ],



      cultureItems: [
        //企业理念 
        {
          title: '企业理念',
          content: '诚信为本、创新为志、服务为源'
        },
        //企业价值观 
        {
          title: '企业价值观',
          content: '以人为本、尊重知识、重视人才'
        },
        //企业准则 
        {
          title: '企业准则',
          content: '踏实敬业、开拓进取、专业高效'
        },
      ],
      //办公地点
      officeLocation: [
        {
          value: 0,
          location: '成都',
          //详细地址
          address: '成都市武侯大道顺江段77号（吾悦广场）2栋1304',
          //邮编
          postcode: '610045',
          //电话
          telephone: '028-87549100'
        },
        {
          value: 1,
          location: '西昌',
          //详细地址
          address: '凉山州西昌市外滩16区三栋一单元902',
          //邮编
          postcode: '615000',
          //电话
          telephone: '028-87549100'
        }
      ],
      //默认办公地址
      officeIndex: 0,
      officeItem: {},
    }
  },
  mounted () {
    this.$emit("updateToolbarValue", 1)
  },
  created () {
    this.init()
  },
  methods: {
    //初始化
    init () {
      this.officeItem = this.officeLocation[this.officeIndex];
    },
    //点击导航栏页面滚动到指定位置
    toRoll (index) {
      //   网页被卷去的高   offsetTop
      window.scrollTo(0, this.$refs["part" + index].offsetTop + 1)
    },
    //切换地址
    updateOfficeItem (value) {
      this.officeIndex = value;
      this.officeItem = this.officeLocation[value]
    }
  }

}
</script>

<style scoped>
.left-center-style {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.center-style {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.back {
  height: 300px;
  background-position: center center !important;
}
.page-name {
  max-width: 400px;
  margin-left: 30px;
  flex: none;
  font-size: 25px;
  color: white;
  font-family: "宋体";
}

.navigation {
  margin-top: 20px;
  background: inherit;
  border: 1px solid white;
  border-color: transparent;
  width: 600px;
  box-shadow: none;
}
.navigation >>> .v-btn {
  font-size: 20px;
  width: 250px;
  margin-left: 30px;
}
.part-title {
  width: 100%;
  margin-bottom: 40px;
  height: 50px;
  overflow: hidden;
  text-align: center;
  font-size: 30px;
  color: #2a2e2e;
  font-family: "微软雅黑";
}
.desc {
  font-size: 14px;
  color: #5f6464;
  letter-spacing: 0;
  text-align: center;
  line-height: 25px;
  margin: 0 auto 16px auto;
}

.development-history {
  margin: 20px;
  max-width: 600px;
}

.vision-row {
  margin: 50px;
  padding-top: 40px;
  padding-bottom: 50px;
  min-height: 300px;
  align-items: center;
}
.vision-title {
  width: 50%;
  font-size: 30px;
  color: #2a2e2e;
  letter-spacing: 0;
  font-family: "微软雅黑";
  flex: none;
  text-align: center;
}
.right-style {
  flex: none;
  width: 49%;
  text-align: center;
  max-width: 400px;
}
.leaders {
  display: flex;
  justify-content: center;
  align-items: center;
}
.laeder {
  margin: 30px;
  height: 250px;
  max-width: 250px;
}
.laeder-photo {
  height: 50%;
  align-items: flex-end;
}
.laeder-name {
  font-size: 20px;
  margin-left: 20px;
  color: #0052d9;
  line-height: 30px;
}
.laeder-position {
  line-height: 30px;
}

.desc2 {
  font-size: 20px;
  color: #5f6464;
  line-height: 25px;
  margin: 0 auto 16px auto;
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.office-style {
  font-size: 20px;
  margin: 20px 20px 0 25px;
  cursor: pointer;
  position: relative;
}
.office-location {
  width: 300px;
  font-size: 14px;
  line-height: 25px;
  color: #5f6464;
  position: absolute;
  top: 50px;
}
</style>